import { render, staticRenderFns } from "./QuotePaymentTermTemplateList.vue?vue&type=template&id=4ef5100f&"
import script from "./QuotePaymentTermTemplateList.vue?vue&type=script&lang=ts&"
export * from "./QuotePaymentTermTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports